import InnerBox from '@repo/ui/inner-box'
import MultiSelectInput from '@repo/ui/multiselect-input'
import { useFormContext } from 'react-hook-form'

import useTranslate from '../../../lib/hooks/use-translate'
import {
  SchoolLevelTaughtEnum,
  schoolLevelTaughtEnumMapping
} from '../../../lib/types/enums/staff-application/school-level-taught.enum'
import { StaffApplicationInput } from '../../../lib/types/models/staff-application/staff-application-input'
import ControlledSwitch from '../../elements/controlled-switch'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'

const StaffApplicationFormProfessionalExperience = () => {
  const { t } = useTranslate()
  const form = useFormContext<StaffApplicationInput>()

  return (
    <InnerBox title="Expérience professionnelle">
      <div className="flex flex-col gap-4">
        <FormField
          control={form.control}
          name="currentSituation"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput {...field} type="text" label="Situation actuelle" />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="currentStudiedDomain"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput {...field} type="text" label="Domaine d'étude" />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="classLevels"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <MultiSelectInput
                  {...field}
                  variant="primary"
                  label="Niveaux enseignés"
                  options={Object.values(SchoolLevelTaughtEnum).map((status) => ({
                    label: t(schoolLevelTaughtEnumMapping[status]),
                    value: status
                  }))}
                  selectedOptions={field.value?.map((id) => ({
                    label: t(schoolLevelTaughtEnumMapping[id]),
                    value: id
                  }))}
                />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="hasSuperVisionExperienceOverSevenDays"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledSwitch
                  {...field}
                  label="A une expérience de supervision pendant plus de sept jours"
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </InnerBox>
  )
}

export default StaffApplicationFormProfessionalExperience
